import { API_REQUEST, AUTOCOMPLETE, NBH_SEARCH, SEARCH_CONFIG, COORDS, ROLLLIST, CITYCOORDS } from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types";


export const getSearchConfig = (): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/search/config/`,
        next: SEARCH_CONFIG,
        method: 'GET',
        authorization: true
    }
});

export const searchAutoComplete = (search: string, type: string, city: string): AppAction => {
    const action: AppAction = {
        type: API_REQUEST,
        payload: {
            url: `/search/autocomplete/`,
            next: AUTOCOMPLETE,
            data: {
                search_addr: search,
                search_city: city !== "" ? city : null,
                is_condo: false,
                is_comm: false
            },
            method: 'POST',
            authorization: true
        }
    }

    if(type === "CONDO") {
        (action["payload"]["data"] as Record<string, unknown>)["is_condo"]= true;

    } else if (type === "COMM") {
        (action["payload"]["data"] as Record<string, unknown>)["is_comm"] = true;
    }
    return action;
}

export interface Range {
    from: number | null;
    to: number | null;
}

export interface UomRange {
    uom: "A" | "F" | "M";
    min: number | null;
    max: number | null;
}

export interface BaseSearchPayload extends Record<string, unknown> {
    page: number,
    search_addr?: string,
    search_city?: string | null
}

export interface ResSearchPayload extends BaseSearchPayload {

    prop_desc: string | null;
    year_built: Range,
    ext_sqft: Range,
    num_full_storey: number | null,
    num_part_storey: number | null,
    lot_size: UomRange,
    frontage: UomRange,
}

export interface CondoSearchPayload extends BaseSearchPayload {
    num_bath: number | null;
    num_bed: number | null;
    unit_num: string | null;
}

export interface CommercialSearchPayload extends BaseSearchPayload {
    code: number | null;
}

export interface RollSearchPayload extends BaseSearchPayload {
    roll: string | null;
}

export type SearchPayload = ResSearchPayload | CondoSearchPayload | CommercialSearchPayload | RollSearchPayload;

export const searchFull = (data: SearchPayload): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/search/full/`,
        next: NBH_SEARCH,
        data: data,
        method: 'POST',
        authorization: true
    }
});

export const searchCoords = (roll: string): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/search/getCoordsByRoll/${roll}`,
        next: COORDS,
        method: 'GET',
        authorization: true
    }
})

export const searchRollList = (lat: number, lng: number): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/search/getRollsByCoords/${lat}/${lng}`,
        next: ROLLLIST,
        method: 'GET',
        authorization: true
    }
})

export const searchCityCoords = (city:Record<string, unknown>): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/search/getCoordsByName/`,
        next: CITYCOORDS,
        data: city,
        method: 'POST',
        authorization: true
    }
})